import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { setDrugsAndAlcoholIndicatorsOptions } from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'

export function* getDrugsAndAlcoholIndicatorsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getDrugsAndAlcoholIndicatorsOptions])
    const { entity } = response
    yield put(setDrugsAndAlcoholIndicatorsOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getDrugsAndAlcoholIndicatorsOptions() error: ${e}`))
  }
}

export function* getDrugsAndAlcoholIndicatorsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getDrugsAndAlcoholIndicatorsOptions)
}
